/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Trash2 } from 'lucide-react';

const DATE_OPTIONS = {
  weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
};

function RequestDeleteModal({ closeModal, handleDelete, request }) {
  const [deleting, setDeleting] = useState(false);
  const start = request?.startDate ? new Date(request.startDate) : null;
  const end = request?.endDate ? new Date(request.endDate) : null;

  const onConfirm = async () => {
    setDeleting(true);
    await handleDelete();
    setDeleting(false);
  };

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c">
      <Box style={{
        width: 480,
        maxWidth: 'calc(100% - 32px)',
        padding: 24,
        background: '#fff',
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
      >
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#CC4525] text-white">
          <Trash2 size={22} />
        </div>
        <h5 className="text-lg font-semibold leading-none text-ink-900 mb-0">
          Are you sure to delete this request?
        </h5>
        <p className="text-sm text-ink-500 leading-relaxed mb-0">
          You&apos;re about to delete the &ldquo;
          {start && <span className="font-semibold text-ink-900">{start.toLocaleDateString('en-US', DATE_OPTIONS)}</span>}
          {' '}
          to
          {' '}
          {end && <span className="font-semibold text-ink-900">{end.toLocaleDateString('en-US', DATE_OPTIONS)}</span>}
          &rdquo; requested PTO and you have to apply again if needed.
        </p>
        <div className="flex justify-start items-center gap-2">
          <button
            type="button"
            onClick={closeModal}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            className="inline-flex items-center justify-center px-4 py-2 bg-[#CC4525] text-white rounded-[8px] text-sm font-semibold hover:bg-[#a8391d] disabled:opacity-50 transition"
          >
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </Box>
    </Modal>
  );
}

RequestDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  request: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

RequestDeleteModal.defaultProps = {
  request: {},
};

export default RequestDeleteModal;
